<template>
  <v-menu
    v-model="navigation.contextMenuIsVisible"
    @update:model-value="navigation.contextMenuIsVisible == false ? navigation.contextMenuItem = null : null"
    @contextmenu.prevent="navigation.contextMenuIsVisible = false; navigation.contextMenuItem = null;"
    :activator="false"
    location-strategy="static"
    transition="scroll-y-transition"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-list
      :style="`top: ${navigation.contextMenuY}px; left: ${navigation.contextMenuX}px;`"
      density="compact"
      style="position: absolute; width: 550px; height: auto; max-height: 400px; overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;" 
    >
      <template v-if="navigation.contextMenuItem && navigation.contextMenuItem.type == 'CRMWhatsappProductFollowup'">
        <v-list-item
          @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', navigation.contextMenuItem.CRMWhatsappProductFollowupID);"
          title="Copiar ID del seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="x-small">mdi-barcode</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('select', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, null)"
          title="Ver seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-open-in-app</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('update', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
          title="Actualizar seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-pencil</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('delete', null, navigation.contextMenuItem.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
          title="Eliminar seguimiento de producto"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-source-branch-sync</v-icon>
            <v-icon color="indigo" size="small">mdi-delete</v-icon>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  <v-dialog
    v-model="navigation.dialogIsVisible"
    @update:model-value="navigation.dialogIsVisible == false ? closeDialog() : null"
    @contextmenu.prevent="null"
    :max-width="navigation.fullScreen ? '100vw' : '90vw'"
    :fullscreen="navigation.fullScreen"
    :retain-focus="false"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-card 
      :style="navigation.fullScreen ? 'min-height: 100vh; height: 100vh; max-height: 100vh;' : (loader.startup ? 'min-height: 95vh; height: 95vh; max-height: 95vh;' : 'min-height: 0; height: auto; max-height: 95vh;')"
      style="display: flex; flex-direction: column; overflow: hidden;"
    >
      <v-card color="primary" rounded="0" elevation="0" class="headerCard">
        <div class="titleContainer">
          <v-icon color="indigo" size="large">mdi-source-branch-sync</v-icon>
          <v-icon color="indigo" style="margin-right: 10px;">mdi-history</v-icon>
          <h3>HISTORIAL DE SEGUIMIENTOS DE PRODUCTO</h3>
        </div>
        <div class="actionsContainer">
          <v-tooltip 
            :disabled="systemInformationData.tooltipDisabled"
            :text="navigation.fullScreen == false ? 'Mostrar en pantalla completa' : 'Salir de pantalla completa'"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                @click="navigation.fullScreen = !navigation.fullScreen"
                :disabled="loader.startup"
                size="x-large"
                class="hoverableVIcon"
              >
                {{ navigation.fullScreen == false ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
            </template>
          </v-tooltip>
          <v-btn 
            @click="closeDialog()"
            :disabled="loader.startup"
            color="error" 
            class="hoverableVButton" 
          >
            <v-icon start>mdi-close-circle</v-icon>
            <p>CERRAR</p>
          </v-btn>
        </div>
      </v-card>
      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
      <template v-if="loader.startup">
        <div style="flex: 1; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <AppLoaderScreen
            :appLogoSize="'x-small'"
            :loadingText="'Cargando historial de seguimientos de producto'"
            :dotsToAnimate="3"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <div style="flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; padding: 15px;">
          <div class="twoColumnContainer" style="gap: 10px;">
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px;">
                <v-icon color="indigo">mdi-barcode</v-icon>
                <p><strong>ID:</strong> {{ display.CRMWhatsappContact.CRMWhatsappContactID }}</p>
              </div>
              <div style="display: flex; gap: 5px;">
                <v-icon color="indigo">mdi-card-account-details</v-icon>
                <template v-if="display.CRMWhatsappContact.CRMWhatsappContactSSN == null">
                  <p><strong>SSN:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                </template>
                <template v-else>
                  <p><strong>SSN:</strong> {{ display.CRMWhatsappContact.CRMWhatsappContactSSN }}</p>
                </template>
              </div>
              <div style="display: flex; gap: 5px;">
                <v-icon color="indigo">mdi-account</v-icon>
                <template v-if="display.CRMWhatsappContact.CRMWhatsappContactName == null">
                  <p><strong>Nombre:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                </template>
                <template v-else>
                  <p><strong>Nombre:</strong> {{ display.CRMWhatsappContact.CRMWhatsappContactName }}</p>
                </template>
              </div>
            </div>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px;">
                <v-icon color="indigo">mdi-phone</v-icon>
                <template v-if="display.CRMWhatsappContact.CRMWhatsappContactPhoneNumber == null">
                  <p><strong>Teléfono:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                </template>
                <template v-else>
                  <p><strong>Teléfono:</strong> {{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappContact.CRMWhatsappContactPhoneNumber) }}</p>
                </template>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-email</v-icon>
                <template v-if="display.CRMWhatsappContact.CRMWhatsappContactEmail == null">
                  <p><strong>Correo electrónico:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                </template>
                <template v-else>
                  <p><strong>Correo electrónico:</strong> {{ display.CRMWhatsappContact.CRMWhatsappContactEmail }}</p>
                </template>
              </div>
              <div style="display: flex; gap: 5px;">
                <v-icon color="indigo">mdi-store</v-icon>
                <template v-if="display.CRMWhatsappContact.CRMWhatsappContactCRMLocalityID == null">
                  <p><strong>Localidad:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrada</span></p>
                </template>
                <template v-else>
                  <p><strong>Localidad:</strong></p>
                  <v-chip
                    :color="display.CRMWhatsappContact.CRMWhatsappContactCRMLocalityColor || 'primary'"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                    style="margin-left: 5px;"
                  >
                    <p>{{ display.CRMWhatsappContact.CRMWhatsappContactCRMLocalityName }}</p>
                  </v-chip>
                </template>
              </div>
            </div>
          </div>
          <v-card elevation="2" style="border: 2px solid #343A40; margin-top: 30px;">
            <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                <p><strong>Seguimientos asociados</strong></p>
              </div>
            </v-card>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <template v-if="display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowup.length > 0">
              <v-data-table
                :headers="computed_CRMWhatsappProductFollowupHeaders"
                :items="display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowup"
                :hover="display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowup.length > 1"
                :items-per-page="-1"
                fixed-header
                style="max-height: 800px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
              >
                <template v-slot:headers="{ columns }">
                  <tr>
                    <template
                      v-for="column in columns"
                      :key="column.value"
                    >
                      <th>
                        <v-card elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%; padding: 0px 25px;">
                          <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).index > 0">
                            <v-icon 
                              @click="updateTableHeaderIndex('CRMWhatsappProductFollowup', column.value, -1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-right: 10px"
                            >
                              mdi-arrow-left-bold
                            </v-icon>
                          </template>
                          <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).icon }}</v-icon>
                          <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible">
                            <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).title }}</strong></p>
                          </template>
                          <v-icon 
                            @click="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappProductFollowup')"
                            color="tertiary"
                            size="x-small"
                            class="hoverableVIcon"
                          >
                            mdi-{{ computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                          </v-icon>
                          <template v-if="computed_CRMWhatsappProductFollowupHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappProductFollowupHeaders.length - 1">
                            <v-icon
                              @click="updateTableHeaderIndex('CRMWhatsappProductFollowup', column.value, 1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-left: 10px"
                            >
                              mdi-arrow-right-bold
                            </v-icon>
                          </template>
                        </v-card>
                        <v-card color="grey-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
                      </th>
                    </template>
                  </tr>
                </template>
                <template v-slot:item="row">
                  <tr
                    :class="getTableRowClass('CRMWhatsappProductFollowup', row.item)" 
                    :style="loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog ? 'pointer-events: none;' : null"
                  >
                    <template
                      v-for="header in computed_CRMWhatsappProductFollowupHeaders"
                      :key="header.value"
                    >
                      <td @contextmenu.prevent="navigation.contextMenuIsVisible = true; navigation.contextMenuItem = {'type': 'CRMWhatsappProductFollowup', ...row.item}; navigation.contextMenuX = $event.clientX; navigation.contextMenuY = $event.clientY;">
                        <template v-if="header.value == 'CRMWhatsappProductFollowupID' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <v-hover>
                            <template v-slot="{ isHovering, props: hoverProps }">
                              <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                <v-tooltip text="Copiar ID del seguimiento de producto al portapapeles" location="top">
                                  <template v-slot:activator="{ props: tooltipProps }">
                                    <p 
                                      v-bind="tooltipProps"
                                      @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID)"
                                      class="hoverableVIcon"
                                      style="color: #3F51B5;"
                                    >
                                      <strong>{{ row.item.CRMWhatsappProductFollowupID }}</strong>
                                    </p>
                                  </template>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <p
                                  v-bind="hoverProps"
                                  @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID)"
                                  class="hoverableVIcon"
                                  style="color: #3F51B5;"
                                >
                                  <strong>{{ row.item.CRMWhatsappProductFollowupID }}</strong>
                                </p>
                              </template>
                            </template>
                          </v-hover>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupStatus' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <v-chip
                            :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando inventario)': 'error', 'Pendiente (otro)': 'error', 'Finalizado': 'success', 'Cancelado': 'warning'}[row.item.CRMWhatsappProductFollowupStatus]"
                            variant="flat"
                            elevation="2"
                            density="compact"
                            label
                          >
                            <p>{{ row.item.CRMWhatsappProductFollowupStatus }}</p>
                          </v-chip>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupStock' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <template v-if="row.item.stockCRMWhatsappProductFollowupProductCount == 0">
                            <v-chip color="error" variant="flat" elevation="2" density="compact" label>
                              <p>Sin inventario</p>
                            </v-chip>
                          </template>
                          <template v-else-if="row.item.stockCRMWhatsappProductFollowupProductCount == row.item.totalCRMWhatsappProductFollowupProductCount">
                            <v-chip color="success" variant="flat" elevation="2" density="compact" label>
                              <p>{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? 'El' : `Los ${row.item.totalCRMWhatsappProductFollowupProductCount}`}} producto{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 's' }} tiene{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 'n' }} inventario</p>
                            </v-chip>
                          </template>
                          <template v-else>
                            <v-chip color="warning" variant="flat" elevation="2" density="compact" label>
                              <p>{{ row.item.stockCRMWhatsappProductFollowupProductCount }} de {{ row.item.totalCRMWhatsappProductFollowupProductCount }} producto{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 's' }} tiene{{ row.item.totalCRMWhatsappProductFollowupProductCount == 1 ? null : 'n' }} inventario</p>
                            </v-chip>
                          </template>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupNote' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <template v-if="row.item.CRMWhatsappProductFollowupNote == null || !/\S/.test(row.item.CRMWhatsappProductFollowupNote)">
                            <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">Sin nota</p>
                          </template>
                          <template v-else>
                            <p style="width: 400px; max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">{{ row.item.CRMWhatsappProductFollowupNote }}</p>
                          </template>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupCreationCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <v-chip
                            :color="row.item.CRMWhatsappProductFollowupCreationCRMAgentColor || 'primary'"
                            variant="flat"
                            elevation="2"
                            label
                          >
                            <div style="display: flex; align-items: center;">
                              <img
                                :src="row.item.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL"
                                :draggable="false"
                                style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                              >
                              <div style="display: flex; flex-direction: column;">
                                <p>{{ row.item.CRMWhatsappProductFollowupCreationCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupCreationCRMAgentName }}</p>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                  <v-icon size="x-small">mdi-clock</v-icon>
                                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupCreationDatetime) }}</p>
                                </div>
                              </div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupUpdateCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <template v-if="row.item.CRMWhatsappProductFollowupUpdateCRMAgentID == null">
                            <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No actualizado</p>
                          </template>
                          <template v-else>
                            <v-chip
                              :color="row.item.CRMWhatsappProductFollowupUpdateCRMAgentColor || 'primary'"
                              variant="flat"
                              elevation="2"
                              label
                            >
                              <div style="display: flex; align-items: center;">
                                <img
                                  :src="row.item.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL"
                                  :draggable="false"
                                  style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                                >
                                <div style="display: flex; flex-direction: column;">
                                  <p>{{ row.item.CRMWhatsappProductFollowupUpdateCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupUpdateCRMAgentName }}</p>
                                  <div style="display: flex; align-items: center; gap: 5px;">
                                    <v-icon size="x-small">mdi-clock</v-icon>
                                    <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupUpdateDatetime) }}</p>
                                  </div>
                                </div>
                              </div>
                            </v-chip>
                          </template>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupCompletionCRMAgent' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <template v-if="row.item.CRMWhatsappProductFollowupCompletionCRMAgentID == null">
                            <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No finalizado</p>
                          </template>
                          <template v-else>
                            <v-chip
                              :color="row.item.CRMWhatsappProductFollowupCompletionCRMAgentColor || 'primary'"
                              variant="flat"
                              elevation="2"
                              label
                            >
                              <div style="display: flex; align-items: center;">
                                <img
                                  :src="row.item.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : row.item.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL"
                                  :draggable="false"
                                  style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                                >
                                <div style="display: flex; flex-direction: column;">
                                  <p>{{ row.item.CRMWhatsappProductFollowupCompletionCRMAgentName == null ? 'No registrado' : row.item.CRMWhatsappProductFollowupCompletionCRMAgentName }}</p>
                                  <div style="display: flex; align-items: center; gap: 5px;">
                                    <v-icon size="x-small">mdi-clock</v-icon>
                                    <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappProductFollowupCompletionDatetime) }}</p>
                                  </div>
                                </div>
                              </div>
                            </v-chip>
                          </template>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupActions' && display.CRMWhatsappProductFollowupHeaders.find(currentCRMWhatsappProductFollowupHeader => currentCRMWhatsappProductFollowupHeader.value == header.value).visible">
                          <v-menu
                            @update:model-value="navigation.contextMenuItem = null"
                            @contextmenu.prevent="null"
                            transition="scroll-y-transition"
                            scrim="black"
                            opacity="0.8"
                            style="user-select: none; cursor: default;"
                          >
                            <template v-slot:activator="{ props }">
                              <v-btn
                                v-bind="props"
                                @click="navigation.contextMenuItem = {'type': 'CRMWhatsappProductFollowup', ...row.item}"
                                color="indigo"
                                density="compact"
                                class="hoverableVButton"
                              >
                                <v-icon start>mdi-dots-vertical</v-icon>
                                <p style="font-size: small;">ACCIONES</p>
                              </v-btn>
                            </template>
                            <v-list density="compact" style="overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">
                              <v-list-item
                                @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupID);" 
                                title="Copiar ID del seguimiento de producto" 
                                class="hoverableVListItem" 
                              >
                                <template v-slot:prepend>
                                  <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                                  <v-icon color="indigo" size="x-small">mdi-barcode</v-icon>
                                </template>
                              </v-list-item>
                              <v-list-item
                                @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('select', null, row.item.CRMWhatsappProductFollowupID, null, null)"
                                title="Ver seguimiento de producto"
                                class="hoverableVListItem"
                              >
                                <template v-slot:prepend>
                                  <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                                  <v-icon color="indigo" size="small">mdi-open-in-app</v-icon>
                                </template>
                              </v-list-item>
                              <v-list-item
                                @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('update', null, row.item.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
                                title="Actualizar seguimiento de producto"
                                class="hoverableVListItem"
                              >
                                <template v-slot:prepend>
                                  <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                                  <v-icon color="indigo" size="small">mdi-pencil</v-icon>
                                </template>
                              </v-list-item>
                              <v-list-item
                                @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('delete', null, row.item.CRMWhatsappProductFollowupID, null, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
                                title="Eliminar seguimiento de producto"
                                class="hoverableVListItem"
                              >
                                <template v-slot:prepend>
                                  <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                                  <v-icon color="indigo" size="small">mdi-delete</v-icon>
                                </template>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-slot:bottom></template>
              </v-data-table>
            </template>
            <template v-else>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 15px; gap: 5px; height: 150px;">
                <v-icon color="tertiary" size="small">mdi-information</v-icon>
                <p style="color: #9e9e9e; font-size: small;">No se ha encontrado ningún seguimiento de producto asociado a este contacto</p>
              </div>
            </template>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-card elevation="0" rounded="0" color="primary" class="footer">
              <v-btn
                @click="$root.dialogComponent.openCRMWhatsappProductFollowupDialog('insert', navigation.CRMWhatsappContactID, null, navigation.CRMWhatsappConversationID, (() => this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(true)))"
                :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog"
                color="indigo"
                density="comfortable"
                class="hoverableVButton"
              >
                <v-icon start size="small">mdi-plus-circle</v-icon>
                <p style="font-size: small">REGISTRAR</p>
              </v-btn>
              <div class="paginationContainer">
                <template v-if="display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowup.length > 0">
                  <v-pagination
                    v-model="navigation.CRMWhatsappProductFollowupPage"
                    @update:model-value="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(false)"
                    :length="Math.ceil(display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount / navigation.CRMWhatsappProductFollowupLimit)"
                    :disabled="loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog"
                    :total-visible="5"
                    density="compact"
                    size="small"
                  ></v-pagination>
                  <p style="font-size: x-small;">{{ (display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount == 0) ? '0 de 0 seguimientos' : `${(navigation.CRMWhatsappProductFollowupPage - 1) * navigation.CRMWhatsappProductFollowupLimit + 1} - ${Math.min(navigation.CRMWhatsappProductFollowupPage * navigation.CRMWhatsappProductFollowupLimit, display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount)} de ${display.CRMWhatsappContact.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCount} seguimientos`}}</p>
                </template>
              </div>
            </v-card>
          </v-card>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .twoColumnContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 10px;
  }
  .paginationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }
  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      margin-left: 0;
      justify-content: center;
    }
    .twoColumnContainer {
      grid-template-columns: 1fr;
    }
    .footer {
      flex-direction: column;
      justify-content: center;
    }
    .paginationContainer {
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components:
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      display: 
      {
        CRMWhatsappContact: null,
        CRMWhatsappProductFollowupHeaders: []
      },
      navigation: 
      {
        dialogIsVisible: false,
        fullScreen: false,
        CRMWhatsappContactID: null,
        CRMWhatsappConversationID: null,
        contextMenuIsVisible: false,
        contextMenuItem: null,
        contextMenuX: 0,
        contextMenuY: 0,
        CRMWhatsappProductFollowupPage: 1,
        CRMWhatsappProductFollowupLimit: 100
      },
      loader: 
      {
        startup: false,
        selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),
    computed:
    {
      computed_CRMWhatsappProductFollowupHeaders(){
        return this.display.CRMWhatsappProductFollowupHeaders.slice().sort((CRMWhatsappProductFollowupHeaderA, CRMWhatsappProductFollowupHeaderB) => CRMWhatsappProductFollowupHeaderA.index - CRMWhatsappProductFollowupHeaderB.index);
      }
    },
    methods:
    {
      async selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialog(){
        const selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialog', selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialogRequestQuery);
        if (selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialogResult.success) this.display.CRMWhatsappContact = selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialogResult.result;
        else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeDialog();
        }
      },
      async selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog(isNewSearch){
        if (isNewSearch) this.navigation.CRMWhatsappProductFollowupPage = 1;
        this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog = true;
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialogRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'page': this.navigation.CRMWhatsappProductFollowupPage,
          'limit': this.navigation.CRMWhatsappProductFollowupLimit
        };
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog', selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialogRequestBody);
        if (selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialogResult.success) this.display.CRMWhatsappContact.CRMWhatsappProductFollowup = selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialogResult.result;
        else this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar el seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog = false;
      },
      updateTableHeaderIndex(tableName, headerValue, headerIndexChange){
        const updatedTableHeader = this.display[`${tableName}Headers`].find(header => header.value == headerValue);
        const swappedTableHeader = this.display[`${tableName}Headers`].find(header => header.index == (this.display[`${tableName}Headers`].find(header => header.value == headerValue).index + headerIndexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        localStorage.setItem(`CRMWhatsappProductFollowupHistoryDialog_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      updateTableVisibility(tableName){
        localStorage.setItem(`CRMWhatsappProductFollowupHistoryDialog_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      getTableRowClass(tableName, item){
        if (tableName == 'CRMWhatsappProductFollowup'){
          if (this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupHistoryDialog) return 'loadingVDataTableRow';
          if (this.navigation.contextMenuItem != null) {
            if (this.navigation.contextMenuItem.CRMWhatsappProductFollowupID == item.CRMWhatsappProductFollowupID) return 'selectedVDataTableRow';
            return 'bluredVDataTableRow';
          }
          if (item.stockCRMWhatsappProductFollowupProductCount == item.totalCRMWhatsappProductFollowupProductCount) return 'successVDataTableRow';
        }
        return null;
      },
      async prepareTables(){
        const CRMWhatsappProductFollowupHeaders = 
        [
          {title: 'ID', value: 'CRMWhatsappProductFollowupID', icon: 'mdi-barcode', visible: true},
          {title: 'ESTADO', value: 'CRMWhatsappProductFollowupStatus', icon: 'mdi-source-branch', visible: true},
          {title: 'INVENTARIO', value: 'CRMWhatsappProductFollowupStock', icon: 'mdi-package', visible: true},
          {title: 'NOTA', value: 'CRMWhatsappProductFollowupNote', icon: 'mdi-text-box', visible: true},
          {title: 'CREACIÓN', value: 'CRMWhatsappProductFollowupCreationCRMAgent', icon: 'mdi-account-plus', visible: true},
          {title: 'ACTUALIZACIÓN', value: 'CRMWhatsappProductFollowupUpdateCRMAgent', icon: 'mdi-account-edit', visible: true},
          {title: 'FINALIZACIÓN', value: 'CRMWhatsappProductFollowupCompletionCRMAgent', icon: 'mdi-account-check', visible: true},
          {title: 'ACCIONES', value: 'CRMWhatsappProductFollowupActions', icon: 'mdi-dots-vertical', visible: true}
        ].map((header, index) => ({ ...header, index: index }));
        let localStorageHeaders = JSON.parse(localStorage.getItem('CRMWhatsappProductFollowupHistoryDialog_CRMWhatsappProductFollowupHeaders') || JSON.stringify(CRMWhatsappProductFollowupHeaders));
        for (const localStorageHeader of localStorageHeaders){
          const CRMWhatsappProductFollowupHeader = CRMWhatsappProductFollowupHeaders.find(CRMWhatsappProductFollowupHeader => CRMWhatsappProductFollowupHeader.value == localStorageHeader.value);
          if (CRMWhatsappProductFollowupHeader){
            if (localStorageHeader.visible != null) CRMWhatsappProductFollowupHeader.visible = localStorageHeader.visible;
            if (localStorageHeader.index != null) CRMWhatsappProductFollowupHeader.index = localStorageHeader.index;
          }
        }
        this.display.CRMWhatsappProductFollowupHeaders = CRMWhatsappProductFollowupHeaders.slice().sort((CRMWhatsappProductFollowupHeaderA, CRMWhatsappProductFollowupHeaderB) => CRMWhatsappProductFollowupHeaderA.index - CRMWhatsappProductFollowupHeaderB.index);
      },
      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappProductFollowupHistoryDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappProductFollowupHistoryDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      async openCRMWhatsappProductFollowupHistoryDialog(CRMWhatsappContactID, CRMWhatsappConversationID){
        this.loader.startup = true;
        await this.getSystemInformation();
        await this.prepareTables();
        this.navigation.dialogIsVisible = true;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        await this.selectCRMWhatsappContactFromCRMWhatsappProductFollowupHistoryDialog();
        this.loader.startup = false;
      },
      closeDialog(){
        if (this.systemInformationData.updateSubscription){
          systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
          this.systemInformationData.updateSubscription = null;
        }
        this.navigation.dialogIsVisible = false;
        this.$emit('closeCRMWhatsappProductFollowupHistoryDialog');
      },
      beforeUnmount(){
        if (this.systemInformationData.updateSubscription){
          systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
          this.systemInformationData.updateSubscription = null;
        }
      }
    }
  }
</script>